import type { CardFeatures } from '../../CardFeatures';
import { accountLinkage } from '../account-linkage/RS';
import { dynamicCurrencyConversion } from '../card-dynamic-currency-conversion/RS';
import { cardImage } from '../card-image/RS';
import { cardInsurance } from '../card-insurance/RS';
import { limitsChange } from '../card-limits-change/RS';
import { cardLimitsFocusPage } from '../card-limits-focus-page/RS';
import { limits } from '../card-limits/combined-limits/RS';
import { permanentLimitsLegacy } from '../card-limits/permanent-limits-legacy/RS';
import { permanentLimits } from '../card-limits/permanent-limits/RS';
import { temporaryLimits } from '../card-limits/temporary-limits/RS';
import { cardLockAndReplace } from '../card-lock-and-replace/RS';
import { cardLock } from '../card-lock/RS';
import { prepaidCardInfo } from '../card-prepaid-info/RS';
import {
    card3DSecureCode,
    card3DSecureCodeEncryption,
} from '../card-services/card-3d-secure-code/RS';
import { automaticCardReplacement } from '../card-services/card-automatic-replacement/RS';
import { cardCancellation } from '../card-services/card-cancellation/RS';
import { cardDelivery } from '../card-services/card-delivery/RS';
import { changeCardDesign } from '../card-services/card-design-change/RS';
import { cardLoyaltyProgramExternal } from '../card-services/card-loyalty-external/RS';
import { supplementaryCardInstallments } from '../card-services/supplementary-card-installments/RS';
import { cardMigrationExternal } from '../card-services/card-migration-external/RS';
import { creditCardReissueExternal } from '../card-services/card-reissue-external/RS';
import { cardReissue } from '../card-services/card-reissue/RS';
import { orderReplacementCard } from '../card-services/card-replacement/RS';
import { cardDetails, cardDetailsEncryption } from '../card-services/card-secured-details/RS';
import { changeCardDelivery } from '../card-services/delivery-management-v2/RS';
import { displayPin, displayPinEncryption } from '../card-services/display-pin/RS';
import { changePinDelivery } from '../card-services/pin-delivery-change/RS';
import { pinDeliveryFromCardDelivery } from '../card-services/pin-delivery-from-card-delivery/RS';
import { pinDelivery } from '../card-services/pin-delivery/RS';
import { reprintPinFocusPage } from '../card-services/reprint-pin-focus-page/RS';
import { reprintPin } from '../card-services/reprint-pin/RS';
import { cardTracking } from '../card-tracking/RS';
import { cardUnlock } from '../card-unlock/RS';
import { bankCardLimitChange } from '../cards-bank/card-limit-changes/RS';
import { cardLimitInfo } from '../cards-bank/card-limit-info/RS';
import { cardReplacement } from '../cards-bank/card-replacement/RS';
import { geoControl } from '../cards-bank/geo-control/RS';
import { linkedAccounts } from '../cards-bank/linked-accounts/RS';
import { microCardActivation } from '../cards-bank/micro-card-activation/RS';
import { microSticker } from '../cards-bank/micro-sticker/RS';
import { cardServices } from '../cards-credit/additional-services/RS';
import { cardFees } from '../cards-credit/card-fees/RS';
import { creditCardLimitChange } from '../cards-credit/card-limit-change/RS';
import { creditCardLimitInfo } from '../cards-credit/card-limit-info/RS';
import { creditCardMeter } from '../cards-credit/card-meter/RS';
import { creditCardDirectDebit } from '../cards-credit/direct-debit/RS';
import { creditCardPayUp } from '../cards-credit/pay-up/RS';
import { autoRepayment } from '../cards-credit/repayment/RS';
import { creditCardStatements } from '../cards-credit/statements/RS';
import { contactlessPayments } from '../contactless-payments/RS';
import { expirationTime } from '../expiration-time/RS';
import { installmentsActivation } from '../installments-activation/RS';
import { installments } from '../installments/RS';
import { temporaryDeactivation } from '../temporary-deactivation/RS';
import { topUp } from '../top-up/RS';
import { upcomingInstallments } from '../upcoming-installments/RS';

export const cards: CardFeatures = {
    accountLinkage,
    autoRepayment,
    bankCardLimitChange,
    card3DSecureCode,
    card3DSecureCodeEncryption,
    cardCancellation,
    cardDelivery,
    cardDetails,
    cardDetailsEncryption,
    cardFees,
    cardInsurance,
    cardLimitInfo,
    cardLock,
    cardLockAndReplace,
    cardLoyaltyProgramExternal,
    cardMigrationExternal,
    cardReissue,
    cardReplacement,
    cardServices,
    cardTracking,
    supplementaryCardInstallments,
    cardUnlock,
    changeCardDesign,
    contactlessPayments,
    creditCardLimitChange,
    creditCardLimitInfo,
    creditCardReissueExternal,
    creditCardStatements,
    displayPin,
    displayPinEncryption,
    dynamicCurrencyConversion,
    expirationTime,
    geoControl,
    installments,
    installmentsActivation,
    upcomingInstallments,
    limits,
    limitsChange,
    linkedAccounts,
    microCardActivation,
    microSticker,
    permanentLimits,
    permanentLimitsLegacy,
    pinDelivery,
    pinDeliveryFromCardDelivery,
    prepaidCardInfo,
    reprintPin,
    temporaryDeactivation,
    temporaryLimits,
    topUp,
    cardLimitsFocusPage,
    creditCardPayUp,
    reprintPinFocusPage,
    automaticCardReplacement,
    changePinDelivery,
    changeCardDelivery,
    creditCardDirectDebit,
    orderReplacementCard,
    creditCardMeter,
    cardImage,
    relyOnPAPIDataForCards: {
        enabled: false,
    },
    redesignedCardContentBox: {
        enabled: true,
    },
    redesignedDebitCardContentBox: {
        enabled: true,
    },
    additionalCreditCards: {
        enabled: false,
    },
    cardsTicketing: {
        enabled: false,
    },
    nativeCardOrder: {
        enabled: false,
    },
    nativeCardReplacement: {
        enabled: false,
    },
};
